"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataFilter = dataFilter;
exports.dataFormat = dataFormat;
exports.dataSort = dataSort;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _lodash = require("lodash");

var _fuse = _interopRequireDefault(require("fuse.js"));

var _numbers = require("../../helpers/numbers");

var types = _interopRequireWildcard(require("./constants"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function dataFormat(value, type) {
  var removeCommas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var formattedValue;

  switch (type) {
    case types.DATE:
    case types.DATE_STRING:
      formattedValue = new Date(value);
      formattedValue = value ? formattedValue.toISOString() : null;
      formattedValue = formattedValue ? (0, _dayjs["default"])(formattedValue).format('MM/DD/YYYY') : null;
      break;

    case types.DATE_TIME:
      formattedValue = new Date(value);
      formattedValue = value ? formattedValue.toISOString() : null;
      formattedValue = formattedValue ? (0, _dayjs["default"])(formattedValue).format('MM/DD/YYYY hh:mm:ss A') : null;
      break;

    case types.CURRENCY:
      formattedValue = value === null || value === undefined ? null : (0, _numbers.currencyFormatter)(value);
      formattedValue = removeCommas ? formattedValue.replace(/,/g, '') : formattedValue;
      break;

    default:
      formattedValue = value;
  }

  return formattedValue;
}

function dataSort(direction, column, data) {
  var isSearchResults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sortedData = (0, _lodash.cloneDeep)(data);

  if (direction) {
    var isAscending = direction === types.ASCENDING;
    sortedData.sort(function (data1, data2) {
      var value1 = data1[column.key];
      var value2 = data2[column.key];
      var endArray = [null, undefined, ''];

      if (endArray.includes(value1) && endArray.includes(value2)) {
        if (value1 === null && value2 !== null) {
          return 1;
        } else {
          return -1;
        }
      }

      if (endArray.includes(value1)) return 1;
      if (endArray.includes(value2)) return -1;

      switch (column.type) {
        case types.DATE_STRING:
        case types.STRING:
          {
            value1 = value1.toLowerCase().replace(/['"]+/g, '');
            value2 = value2.toLowerCase().replace(/['"]+/g, '');

            if (value1 < value2) {
              return isAscending ? -1 : 1;
            } else if (value1 > value2) {
              return isAscending ? 1 : -1;
            }

            return 0;
          }

        case types.DATE_TIME:
        case types.DATE:
          value1 = Date.parse(value1);
          value2 = Date.parse(value2);

          if (value2 > value1) {
            return isAscending ? -1 : 1;
          } else if (value2 < value1) {
            return isAscending ? 1 : -1;
          }

          return 0;

        case types.CURRENCY:
        case types.NUMBER:
          {
            if (isAscending) {
              return value1 - value2;
            }

            return value2 - value1;
          }

        case types.BOOLEAN:
          {
            if (value1 && !value2) {
              return isAscending ? -1 : 1;
            } else if (value2 && !value1) {
              return isAscending ? 1 : -1;
            }

            return 0;
          }

        default:
          return 0;
      }
    });
  } else if (isSearchResults) {
    // sort data by ascending search results scores
    sortedData.sort(function (data1, data2) {
      return data1.searchScore - data2.searchScore;
    });
  }

  return sortedData;
}

function dataFilter(data, columns, idKey, term) {
  var formattedData = (0, _lodash.cloneDeep)(data);
  var searchableColumns = columns.filter(function (column) {
    return column.canSearch !== undefined ? column.canSearch : true;
  });
  var splitTerm = term.split(':').map(function (val) {
    return val.trim();
  });
  var searchColumn = null;

  if (splitTerm.length > 1) {
    var column = (0, _lodash.find)(searchableColumns, function (column) {
      return column.title.toLowerCase() === splitTerm[0].toLowerCase();
    });
    if (column) searchColumn = column.key;
  } // remove commas then replaces white space between words with +


  var searchTerm = splitTerm[splitTerm.length - 1].replace(/,/g, '').replace(/ /g, '+');
  var fuseConfig = {
    tokenize: true,
    findAllMatches: true,
    shouldSort: true,
    maxPatternLength: 100,
    minMatchCharLength: 1,
    threshold: 0.3,
    // level of matching score needed to be included as a result
    location: 0,
    // tries to look at start of text string first
    distance: 1000,
    keys: searchColumn ? [searchColumn] : searchableColumns.map(function (column) {
      return {
        name: column.key,
        weight: column.weight || 1
      };
    }),
    includeScore: true,
    includeMatches: true // provides array with index places of text that is matched

  };

  if (searchTerm.length > 0) {
    var fuse = new _fuse["default"](formattedData, fuseConfig);
    var results = fuse.search(searchTerm);
    formattedData.forEach(function (row) {
      var matchedRow = results.find(function (matchedRow) {
        return matchedRow.item[idKey] === row[idKey];
      }) || {};
      row.filtered = !(0, _lodash.isEmpty)(matchedRow);
      row.searchScore = !(0, _lodash.isEmpty)(matchedRow) ? matchedRow.score : null;
    });
    var sortedSearchData = dataSort(null, null, formattedData, true);
    return sortedSearchData;
  } else {
    formattedData.forEach(function (row) {
      return row.filtered = true;
    });
    return formattedData;
  }
}